<div class="loaderMaskScreen"></div>
<div class="loaderIcon"><i class="fa fa-spinner"></i></div>